import { useEffect, useState } from 'react'
import { Show } from '@/components/show'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb'
import { cn } from '@/lib/utils'
import type { BreadcrumbItemType } from '@/types/breadcrumb/breadcrumb-item-type'
import { useBreadcrumb } from './hooks/use-breadcrumb'

interface BreadcrumbProps {
  breadClassName?: string
}

export const BreadcrumbLayout = ({ breadClassName }: BreadcrumbProps) => {
  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItemType[]>([])
  const [hasBreadcrumb, setHasBreadcrumb] = useState(false)

  const {
    actions: { getBreadcrumbPath, handleBackBreadcrumb, generateBreadcrumb }
  } = useBreadcrumb()

  useEffect(() => {
    generateBreadcrumb(setBreadcrumb, setHasBreadcrumb)
  }, [])

  return (
    hasBreadcrumb && (
      <Breadcrumb className="font-bold flex items-center">
        <button
          type="button"
          onClick={handleBackBreadcrumb}
          className="me-8 text-2xl cursor-pointer text-[var(--brand-blue-3)]"
        >
          {'<'}
        </button>
        <BreadcrumbList>
          {breadcrumb?.map((item, index) => {
            const isLastItem = index === breadcrumb.length - 1

            return (
              <div key={`breadcrumb-${index}`} className="flex">
                <BreadcrumbItem>
                  {isLastItem ? (
                    <BreadcrumbPage
                      className={cn(
                        'text-2xl font-bold text-ring',
                        breadClassName
                      )}
                    >
                      {item.label}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink
                      href={`${getBreadcrumbPath(breadcrumb, index)}`}
                      className="text-xs text-ring"
                    >
                      {item.label}
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                <Show when={!isLastItem}>
                  <BreadcrumbSeparator></BreadcrumbSeparator>
                </Show>
              </div>
            )
          })}
        </BreadcrumbList>
      </Breadcrumb>
    )
  )
}
